module.exports = __webpack_public_path__ + "img/studio-logo.3f2ed3c4.png";